/** @format */
import { Hyperlink } from '@contentful/rich-text-types';
import { Link } from '@mpb-com/feather/components/atoms/link';
import React, { ReactNode } from 'react';

export const ContentfulLink = (node: Hyperlink, children: ReactNode) => {
    return <Link href={node?.data?.uri}>{children}</Link>;
};
